import { render, staticRenderFns } from "./ModalTabelaOperadora.vue?vue&type=template&id=f220fa26"
import script from "./ModalTabelaOperadora.vue?vue&type=script&lang=ts"
export * from "./ModalTabelaOperadora.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports